export default "__VITE_ASSET__9a21b04a__"